export const COMMON_FETCH_CODETABLES_BEGIN = "COMMON_FETCH_CODETABLES_BEGIN"
export const COMMON_FETCH_CODETABLES_SUCCESS = "COMMON_FETCH_CODETABLES_SUCCESS"
export const COMMON_FETCH_CODETABLES_FAILURE = "COMMON_FETCH_CODETABLES_FAILURE"
export const COMMON_FETCH_CODETABLES_DISMISS_ERROR = "COMMON_FETCH_CODETABLES_DISMISS_ERROR"



// WEBPACK FOOTER //
// ./src/features/common/redux/constants.js